/** Default profile/choice for toolbox router fallbacks. */
export const DEFAULT_TOOLBOX_MODEL = "cheap/default";
